<template>
  <footer>
    <div>
      <div>All contents &copy; Copyright 2014-{{ currentDate() }} Neuro Leap Corp. All rights reserved.</div>
      <div><a href="https://vividkidsblog.page">vividkidsblog.page</a></div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    currentDate() {
      const current = new Date();
      const date = `${current.getFullYear()}`;
      return date;
    }
  }
};
</script>

<style lang="scss" scoped>
@use 'sharedSCSS/globalSharedVariables';

footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: globalSharedVariables.$footerbar-height;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  border-top: 1px solid #D8DBE0;
  background-color: #FFFFFF;
  position: relative;
  z-index: 50;
}
</style>
